import React,{useRef,useEffect,useState,useCallback} from 'react';
import { alpha } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import AppBar from '@mui/material/AppBar';
import CssBaseline from '@mui/material/CssBaseline';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import ListItem from '@mui/material/ListItem';
import MenuIcon from '@mui/icons-material/Menu';
import SearchIcon from '@mui/icons-material/Search';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import Grid from '@mui/material/Grid';
import LinearProgress from '@mui/material/LinearProgress';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { ThemeProvider, StyledEngineProvider } from "@mui/material/styles";
import EditIcon from '@mui/icons-material/Edit';
import { createTheme, List } from "@mui/material";
import axios from 'axios'
import PasswordIcon from '@mui/icons-material/Password';
import InputAdornment from '@mui/material/InputAdornment';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import Visibility from '@mui/icons-material/Visibility';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';

import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';

import HighlightSkuSettings from './highlightSkuSettings/HighlightSkuSettings'
import PoDateSettings from "./poDateSettings/PoDateSettings"
import UserEmailSettings from "./userSettings/UserSettings"
import MfaSettings from "./mfaSettings/MfaSettings"
import AutoGenerateInvoiceNumberSettings from './AutoGenerateInvoiceNumberSettings/AutoGenerateInvoiceNumberSettings';
import { useLocation, useHistory  } from 'react-router-dom';
import PasswordPolicySettings from "./sellerPasswordPolicySettings/SellerPasswordPolicySettings";

const drawerWidth = 300;
const materialTheme = createTheme({
  // set default for now
});

const useStyles = makeStyles((theme) => ({
    appBarSpacer: theme.mixins.toolbar,
   
    appBarReviewOrder: {
      position: 'fixed',
    },
    appBarBottomReviewOrder: {
      top: 'auto',
      bottom: 0
    },
    titleBarReviewOrder: {
      marginLeft: theme.spacing(2),
      flex: 1,
    },
    appBarTop: {
        [theme.breakpoints.up('sm')]: {
          width: `calc(100% - ${drawerWidth}px)`,
          marginLeft: drawerWidth,
        },
      },
      menuButton: {
        marginRight: theme.spacing(2),
        [theme.breakpoints.up('sm')]: {
          display: 'none',
        },
      },
  text: {
    padding: theme.spacing(2, 2, 0),
  },
  paper: {
    paddingBottom: 50,
  },
  list: {
    marginBottom: theme.spacing(2),
  },
  subheader: {
    backgroundColor: theme.palette.background.paper,
  },
  appBarBottom: {
    top: 'auto',
    bottom: 0,
    [theme.breakpoints.up('sm')]: {
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: drawerWidth,
      },
  },
  grow: {
    flexGrow: 1,
  },
  title: {
    flexGrow: 1
  },
  search: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: alpha(theme.palette.common.white, 0.15),
    '&:hover': {
      backgroundColor: alpha(theme.palette.common.white, 0.25),
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(3),
      width: 'auto',
    },
  },
  menu: {
    boxShadow: '0px 1px 5px rgba(0, 0, 0, 0.1)',  // Override the box-shadow here
  },
  hoverableListItem: {
    '&:hover': {
      backgroundColor: '#f5f5f5', // Change the background color as desired
    },
  },

}));


export default function SettingsLists(props) {
    
  const listOfSettings = [
    { name: 'User Settings', value : "user_settings" },
    { name: 'Transacti Seller Transaction P.O Date Settings', value : "seller_po_date" },
    { name: 'Seller Highlight SKU Settings', value : "seller_highlight_skus" },
    { name: 'Reset Password Settings', value : "reset_password_settings" },
    { name: 'Return Product Page Settings', value : "return_product_page_settings" },
    { name: 'Printer Settings', value : "printer_settings" },
    { name: 'Transacti Lite and Seller Auto-generate Invoice Number Settings', value : "auto_generate_invoice_number_settings" },
    { name: 'MFA Settings', value : "mfa_settings" },
    { name: 'Seller Password Policy Setting', value : "seller_password_policy_settings" },
  ]

  const classes = useStyles();
  const [,setAnchorEl] = useState(null);
  const elementRef = useRef(null);
  const [autoCompleteSearchOptionMessage,setAutoCompleteSearchOptionMessage] = useState("No Settings Found")

  const [settingsInfoAnchorElement, setSettingsInfoAnchorElement] = useState(null)
  const [settings, setSettings] = useState(listOfSettings)
  const [isLoading, setIsLoading] = useState(false);
  const [settingsTerm, setSearchSettingsTerm] = useState({name : "", value : ""})
  const [selectedSettings, setSelectedSettings] = useState({name : "", value : ""});
  const [openDialogSettings, setOpenDialogSettings] = useState(false);
  const [openPasswordResetDialogSettings, setOpenPasswordResetDialogSettings] = useState(false);
  const [openPoDateDialog, setOpenPoDateDialog] = React.useState(false);
  const [isSavingSettings, setIsSavingSettings] = useState(false)
  const [showMessageDialog,setShowMessageDialog] = useState(false)
  const [messageDialogMessage,setMessageDialogMessage] = useState("")
  const [isSavingSuccess,setIsSavingSuccess] = useState(false)
  const [actionMessage, setActionMessage] = useState("");
  const [showProgressDialog, setShowProgressDialog] = useState("");
  const [showDeleteProductDialog, setShowDeleteProductDialog] = useState(false)
  const [poDateSettingsTextVal, setPoDateSettingsTextVal] = useState(1)
  const [totalHighlightedSkus, setTotalHighlightedSkus] = useState(0)
  const [poDateSettings, setPODateSettings] = useState({
      value : 1
  })
  //User Settings Dialog
  const [openUserDialogSettings, setOpenUserDialogSettings] = useState(false);
  //MFA Settings Dialog
  const [openMfaDialogSettings, setOpenMfaDialogSettings] = useState(false);

  const [openReturnProductPageSettingsDialog, setOpenReturnProductPageSettingsDialog] = useState(false)
  const [returnProductPageSettings, setReturnProductPageSettings] = useState(1)
  const [returnProductPageSettingsCurStatus, setReturnProductPageSettingsCurStatus] = useState(1)

  const [openRemovePrintButtonSettings, setOpenRemovePrintButtonSettings] = useState(false)
  const [removePrintButtonSettings, setRemovePrintButtonSettings] = useState(0)
  const [removePrintButtonSettingsCurStatus, setRemovePrintButtonSettingsCurStatus] = useState(0)

  

  // AUTO GENERATED INVOICE NUMBER
  const [openAutoGenInvoiceNumberDialog, setOpenAutoGenInvoiceNumberDialog] = useState(false)
  const [autoSalesInvoiceNumberSettings, setAutoSalesInvoiceNumberSettings] = useState([])

  // PASWORD POLICY SETTINGS
  const location = useLocation();
  const history = useHistory();
  const [passwordPolicySettings, setPasswordPolicySettings] = useState([]);
  const { openChangePasswordDialog } = location.state || {}; 

  //seller password policy settings
  const [openSellerPasswordPolicyDialogSettings, setOpenSellerPasswordPolicyDialogSettings] = useState(false);

  
  const [showOldPassword, setShowOldPassword] = useState(true)
  const [showPassword, setShowPassword] = useState(true)
  const [showConfirmPassword, setConfirmShowPassword] = useState(true)
  const [newResetPassword, setNewResetPassword] = useState({
    old_password: '',
    new_password: '',
    re_password: '',
  })
  const resetOldPasswordOnChange = (event) => {
    newResetPassword.old_password = event.target.value
  }
  const resetNewPasswordOnChange = (event) => {
    newResetPassword.new_password = event.target.value
  }
  const resetReNewPasswordOnChange = (event) => {
    newResetPassword.re_password = event.target.value
  }
  

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };


  const settingsBody = () => {
    return (
        <>
            {/* {search()} */}
            {isLoading ? <LinearProgress color="secondary"  style={{marginLeft:'.1rem',marginRight:'.1rem'}}/> : ''}
            <CssBaseline /> 
            {settingsList()}
        </>
    )
  }
  
  const getEditIconClickHandler = (setting_key) => {
    switch (setting_key) {
      case "seller_po_date":
        return handleClickOpen
      case "seller_highlight_skus":
        return () => {
          setOpenDialogSettings(true);
        }
      case "reset_password_settings":
        return handleClickOpenResetPasswordDialog
      case "return_product_page_settings":
        return () => {
          setReturnProductPageSettings(returnProductPageSettingsCurStatus);
          setOpenReturnProductPageSettingsDialog(true);
        };
      case "printer_settings":
        return () => {
          setRemovePrintButtonSettings(removePrintButtonSettingsCurStatus);
          setOpenRemovePrintButtonSettings(true);
        };
      case "auto_generate_invoice_number_settings":
        return () => {
          setOpenAutoGenInvoiceNumberDialog(true);
        };
      case "user_settings":
        return () => setOpenUserDialogSettings(true);
      case "mfa_settings":
        return () => setOpenMfaDialogSettings(true);
      case "seller_password_policy_settings":
        return () => setOpenSellerPasswordPolicyDialogSettings(true);
      default:
        return false;

    }
  };
  
  const settingsList = () => {
    return (
      <>
        <List>
        {settings.map((setting, key) => (
          <React.Fragment key={key + setting.name}>
            <ListItem
              key={key + setting.name}
              divider
              style={{ boxShadow: 'none', cursor: 'pointer' }}
              className={classes.hoverableListItem}
            >
              {settingsElement(setting)}
              
              <EditIcon onClick={getEditIconClickHandler(setting.value)} />
            </ListItem>
          </React.Fragment>
        ))}
        </List>
      </>
    );
  };
  
  

    const settingsElement = (settings) => {
        return (
            <>
            <Grid container style={{padding:"0px"}}
                onClick={
                    (event)=>{
                        setSelectedSettings(settings)
                        setSettingsInfoAnchorElement(event.currentTarget)
                        // setOpenDialogSettings(true)
                    }
                }
            >
                <Grid container item xs={12} >
                  <Grid item xs={9} md={10} lg={11}>
                      <Grid 
                      container
                      direction="column"
                      justifyContent="space-between"
                      alignItems="stretch">
                          <Grid item >
                          <Box style={{ fontWeight:400,fontSize:"20px" }}>{settings.name}</Box>
                          </Grid>
                      </Grid>
                  </Grid>

                    <Grid item xs={9} md={10} lg={11}>
                      <Grid
                        container
                        direction="column"
                        justifyContent="space-between"
                        alignItems="stretch"
                      >
                        <Grid item>
                          <Box style={{ fontWeight: 400, fontSize: "13px" }}>
                            {settings.name === "Transacti Seller Transaction P.O Date Settings" && (
                              <>Current Days: {poDateSettingsTextVal}</>
                            )}
                            {settings.name === "Seller Highlight SKU Settings" && (
                              <>Total Highlighted SKU's: {totalHighlightedSkus}</>
                            )}
                            {settings.name === "Return Product Page Settings" && (
                              <>Current Status:  {(returnProductPageSettingsCurStatus === 1) ? "SHOW" : "HIDE"}</>
                            )}
                             {settings.name === "Printer Settings" && (
                              <>Current Status:  {(removePrintButtonSettingsCurStatus === 1) ? "ON" : "OFF"}</>
                            )}
                            {settings.name === "Transacti Lite and Seller Auto-generate Invoice Number Settings" && (
                              <>{renderAutoGenerateInvoiceNumberCurrentStatus(settings)}</>
                           )}
                            
                          </Box>
                        </Grid>


                      </Grid>
                    </Grid>

                </Grid>
            </Grid>
            </>
        )
    }



    const renderAutoGenerateInvoiceNumberCurrentStatus = (settings) => { 
      return (
        <>
            <Typography style={{ fontWeight: 400, fontSize: "13px" }}>Selected user type : {renderSelectedUserType()}</Typography>
            <Typography style={{ fontWeight: 400, fontSize: "13px" }}>Current Status: {(autoSalesInvoiceNumberSettings.value === 1 || autoSalesInvoiceNumberSettings.value === "1") ? "ON" : "OFF"}  </Typography>
        </>
      )
    }
    
    const iterateUserTypes = () => { 
      if (!autoSalesInvoiceNumberSettings.setting) {
        return
      }

      let userList = "" 
      autoSalesInvoiceNumberSettings.setting.forEach((list, key) => {

        if (list.value) {
          if (key === 0) {
            userList += list.user_type
          } else {
            userList += ", " + list.user_type
          }
        }

      })

      return userList
      
    }
    
    const renderSelectedUserType = () => {
      return (
        <>
          {iterateUserTypes()}
        </>
      )
    }



    useEffect(() => {

        if (!isLoading) {
            return
        }

    }, [settings, returnProductPageSettingsCurStatus, removePrintButtonSettingsCurStatus, isLoading])

    const search = () => {
        return (
            <div position="static" style={{border:".1rem solid #989898",borderRadius:"4px",margin:'2px'}}>
                <Toolbar variant="dense" style={{padding:'0'}}>
                    <Box flexGrow={1}>
                        <Autocomplete
                            value={settingsTerm}
                            noOptionsText={autoCompleteSearchOptionMessage}
                            onChange={(event, newValue) => {
                            
                                if(newValue==null || newValue.name===""){
                                settingsTerm.name = ""
                                settingsTerm.value = ""
                                return
                                }

                                settingsTerm.name = newValue.name
                                settingsTerm.value = newValue.value
                                
                                const foundSetting = listOfSettings.find(setting => setting.name === settingsTerm.name);
                                setSettings([foundSetting])
                            }}
                            
                            selectOnFocus
                            clearOnBlur
                            handleHomeEndKeys
                            options={listOfSettings}
                            isOptionEqualToValue={(option, value) =>true}
                            getOptionLabel={(option) => {
                                
                                    return option.name;
                            }}
                            renderOption={(props, option) => {
                                return (
                                <li {...props} key={option.name}>
                                    {option.name}
                                </li>
                                );
                            }}
                            style={{ width: '100%',paddingLeft:'8px'}}
                            renderInput={(params) => (
                                <TextField
                                {...params}
                                variant='standard'  
                                InputProps={{...params.InputProps, disableUnderline: true}}  
                                
                                onChange={(event)=>{ 
                                setSearchSettingsTerm({name:event.target.value})
                                }
                                } />
                            )}
                        />
                    </Box>
                    <Box>
                        <IconButton 
                            className={classes.margin} 
                            size="large"
                            onClick={()=>{
                                const foundSetting = listOfSettings.filter(setting =>
                                    typeof setting.name === "string" &&
                                    setting.name.toLowerCase().includes(settingsTerm.name.toLowerCase())
                                );
                                
                                if (foundSetting.length === 0 && settingsTerm.name === "") {
                                    setSettings(listOfSettings);
                                    
                                } else {
                                    setSettings(foundSetting);
                                }
                                
                            }}>
                        <SearchIcon />
                        </IconButton>
                    </Box>
                </Toolbar>
            </div>
        )
    }


    const handleClickOpen = () => {
      setOpenPoDateDialog(true);
    };

    const handleClose = () => {
      setOpenPoDateDialog(false);
      setOpenReturnProductPageSettingsDialog(false)
      setOpenRemovePrintButtonSettings(false)
    };

    const poDateSettingsDialog = () => {
      return (
          <div>
          <Dialog open={openPoDateDialog} onClose={handleClose}>
            <DialogTitle> {"P.O DATE SETTINGS"}</DialogTitle>
            <DialogContent>
              
              <Grid container spacing={1}style={{ marginBottom: '.5rem' }}>
                  <Grid item xs={12}>
                      <Grid item xs={12} >Number of Days</Grid>
                      <Grid item xs={12}>
                          <StyledEngineProvider injectFirst>
                              <ThemeProvider theme={materialTheme}>
                              <form noValidate>
                                  <TextField
                                    autoComplete='off'
                                    type='text'
                                    className={classes.fullWidth}
                                    value={poDateSettings.value}
                                    name="value"
                                    id="value"
                                    rows={4}
                                    variant="outlined"
                                    onChange={inputOnChangeListener}
                                    onKeyPress={handleInputKeyPress} // Handle key press to restrict input
                                    onPaste={handlePaste}
                                    style={{ width: "100%" }}
                                  />
                              </form>
                              </ThemeProvider>
                          </StyledEngineProvider>
                      </Grid>
                  </Grid>
              </Grid>

            </DialogContent>
            <DialogActions>
              <Button onClick={handleClose}>Cancel</Button>
              
              <Button color="primary"  onClick={handleSaveSettings}>
                            Save
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      )
    }

    const handleSaveReturnProductPageSettings = async () => {

      setIsSavingSettings(true);
      setOpenReturnProductPageSettingsDialog(false)

      const options = {
          method : "POST",
          url : '/TransactiLiteGeneralSettings/saveReturnProductPageSettings.json',
          data: objectToFormData({
              settings : JSON.stringify(returnProductPageSettings)
          })
      }

      await axios(options)
      .then((res) => {

          setIsSavingSettings(false)
          const message = res.data.response.message;
          const is_success = res.data.response.is_success;

          if(is_success) {
            
            setReturnProductPageSettingsCurStatus(returnProductPageSettings)
          }

          setIsSavingSuccess(true)
          setShowMessageDialog(true)
          setMessageDialogMessage(message)
          
      })
      .catch((error) => {
          setIsSavingSettings(false)

          setShowMessageDialog(true)
          setMessageDialogMessage(error)
      })
  }


    const returnProductPageDialog = () => {
      return (
          <div>
          <Dialog open={openReturnProductPageSettingsDialog} onClose={handleClose}>
            <DialogTitle> {"Return Product Page Settings"}</DialogTitle>
            <DialogContent>
              
              <Grid container spacing={1}style={{ marginBottom: '.5rem' }}>
                  <Grid item xs={12}>
                      <Grid item xs={12}>
                          <StyledEngineProvider injectFirst>
                              <ThemeProvider theme={materialTheme}>
                                    <FormControl fullWidth>
                                    <Select
                                      labelId="demo-simple-select-label"
                                      id="demo-simple-select"
                                      value={returnProductPageSettings}
                                      label="Age"
                                      onChange={(evt) => setReturnProductPageSettings(evt.target.value)}
                                    >
                                      <MenuItem value={1}>SHOW</MenuItem>
                                      <MenuItem value={0}>HIDE</MenuItem>
                                    </Select>
                                  </FormControl>
                              </ThemeProvider>
                          </StyledEngineProvider>
                      </Grid>
                  </Grid>
              </Grid>

            </DialogContent>
            <DialogActions>
              <Button onClick={handleClose}>Cancel</Button>
              
              <Button color="primary"  onClick={handleSaveReturnProductPageSettings}>
                            Save
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      )
    }

    const handleSaveRemovedPrintSettings = async () => {

      setIsSavingSettings(true);
      setOpenRemovePrintButtonSettings(false)

      const options = {
          method : "POST",
          url : '/TransactiLiteGeneralSettings/saveRemovePrintSettings.json',
          data: objectToFormData({
              settings : JSON.stringify(removePrintButtonSettings)
          })
      }

      await axios(options)
      .then((res) => {

          setIsSavingSettings(false)
          const message = res.data.response.message;
          const is_success = res.data.response.is_success;

          if(is_success) {
            
            setRemovePrintButtonSettingsCurStatus(removePrintButtonSettings)
          }

          setIsSavingSuccess(true)
          setShowMessageDialog(true)
          setMessageDialogMessage(message)
          
      })
      .catch((error) => {
          setIsSavingSettings(false)

          setShowMessageDialog(true)
          setMessageDialogMessage(error)
      })
  }


    const removePrintButtonDialog = () => {
      return (
          <div>
          <Dialog open={openRemovePrintButtonSettings} onClose={handleClose}>
            <DialogTitle> {"Removed Print Button Settings"}</DialogTitle>
            <DialogContent>
              
              <Grid container spacing={1}style={{ marginBottom: '.5rem' }}>
                  <Grid item xs={12}>
                      <Grid item xs={12}>
                          <StyledEngineProvider injectFirst>
                              <ThemeProvider theme={materialTheme}>
                                    <FormControl fullWidth>
                                    <Select
                                      labelId="demo-simple-select-label"
                                      id="demo-simple-select"
                                      value={removePrintButtonSettings}
                                      label="Age"
                                      onChange={(evt) => setRemovePrintButtonSettings(evt.target.value)}
                                    >
                                      <MenuItem value={1}>ON</MenuItem>
                                      <MenuItem value={0}>OFF</MenuItem>
                                    </Select>
                                  </FormControl>
                              </ThemeProvider>
                          </StyledEngineProvider>
                      </Grid>
                  </Grid>
              </Grid>

            </DialogContent>
            <DialogActions>
              <Button onClick={handleClose}>Cancel</Button>
              
              <Button color="primary"  onClick={handleSaveRemovedPrintSettings}>
                            Save
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      )
    }
    
    const inputOnChangeListener = (event)=>{
      const modifiedSettings = {...poDateSettings}

      modifiedSettings[event.target.name] = event.target.value
      setPODateSettings(modifiedSettings)

  }

  const handleInputKeyPress = (event) => {
      if (!/^[0-9.]*$/.test(event.key)) {
      event.preventDefault();
      }
  }

  const handlePaste = (event) => {
      event.preventDefault();

      const pastedText = event.clipboardData.getData('text/plain');
      const sanitizedText = pastedText.replace(/[^\d]/g, ''); // Remove non-numeric characters
      document.execCommand('insertText', false, sanitizedText);
  };
  
  const handleSaveSettings = async () => {

      setIsSavingSettings(true);
      setOpenPoDateDialog(false)

      const options = {
          method : "POST",
          url : '/TransactiLiteGeneralSettings/saveTransactiSellerPODateSettings.json',
          data: objectToFormData({
              settings : JSON.stringify(poDateSettings)
          })
      }

      await axios(options)
      .then((res) => {

          setIsSavingSettings(false)
          const message = res.data.response.message;
          const is_success = res.data.response.is_success;

          if(is_success) {
            
            setPoDateSettingsTextVal(poDateSettings.value)
          }

          setIsSavingSuccess(true)
          setShowMessageDialog(true)
          setMessageDialogMessage(message)
          
      })
      .catch((error) => {
          setIsSavingSettings(false)

          setShowMessageDialog(true)
          setMessageDialogMessage(error)
      })
  }

  useEffect(()=> {
          
    fetchExistingSettings();
    fetchTotalSKus()
    fetchExistingReturnProductPageSettings()
    fetchExistingRemovePrintSettings()
    fetchAutoGenerateInvoiceNumberSettings()
    
    fetchPasswordPolicySettings()
    if (props.isNeedToChangePassword || openChangePasswordDialog) {
      setOpenPasswordResetDialogSettings(true)
    }

  },[])

  const fetchPasswordPolicySettings = async() => { 
    
    const options = {
        method : "POST",
        url : '/TransactiLitePasswordPolicySettings/fetchPasswordPolicySettings.json',
    }

    await axios(options)
    .then((res) => {
      setPasswordPolicySettings(res.data.password_policy_settings)
    })
    .catch((error) => {
    })
  }

  useEffect(() => {
    if (location.state && location.state.openDialog) {
        setOpenUserDialogSettings(true);
        setOpenAutoGenInvoiceNumberDialog(true);
        setOpenMfaDialogSettings(true);
        const { state, ...newLocation } = location;
        history.replace(newLocation);
    }
  }, [location.state]);

  const fetchExistingSettings = async () => {
      setIsLoading(true)

      const options = {
          method : "POST",
          url : '/TransactiLiteGeneralSettings/getSellerPoDateSettings.json',
      }

      await axios(options)
      .then((res) => {
          setIsLoading(false)

          
          const message = res.data.response.message;
          const is_success = res.data.response.is_success;
          const settings = res.data.response.settings;

          if (!is_success) {
              setShowMessageDialog(true)
              setMessageDialogMessage(message)
              return
          }

          if (settings.length != 0) {
            setPODateSettings(settings)
            setPoDateSettingsTextVal(settings.value)
          }

      })
      .catch((error) => {
          setIsLoading(false)

          setShowMessageDialog(true)
          setMessageDialogMessage(error)

      })
  }
  
  const fetchTotalSKus = async () => {
    setIsLoading(true)

    const options = {
        method : "POST",
        url : '/TransactiLiteGeneralSettings/getTotalSkus.json',
    }

    await axios(options)
    .then((res) => {
        setIsLoading(false)

        
        const message = res.data.response.message;
        const is_success = res.data.response.is_success;
        const total = res.data.response.total;

        if (!is_success) {
            setShowMessageDialog(true)
            setMessageDialogMessage(message)
            return
        }

        setTotalHighlightedSkus(total)

    })
    .catch((error) => {
        setIsLoading(false)

        setShowMessageDialog(true)
        setMessageDialogMessage(error)

    })
}

  const fetchExistingReturnProductPageSettings = async () => {
    setIsLoading(true)

    const options = {
        method : "POST",
        url : '/TransactiLiteGeneralSettings/fetchExistingReturnProductPageSettings.json',
    }

    await axios(options)
    .then((res) => {
        setIsLoading(false)

        
        const message = res.data.response.message;
        const is_success = res.data.response.is_success;
        const settings = parseInt(res.data.response.settings);

        if (!is_success) {
            setShowMessageDialog(true)
            setMessageDialogMessage(message)
            return
        }
        
        setReturnProductPageSettings(settings)
        setReturnProductPageSettingsCurStatus(settings)

    })
    .catch((error) => {
        setIsLoading(false)

        setShowMessageDialog(true)
        setMessageDialogMessage(error)

    })
  }

  const fetchExistingRemovePrintSettings = async () => {
    setIsLoading(true)

    const options = {
        method : "POST",
        url : '/TransactiLiteGeneralSettings/fetchExistingRemovePrintSettings.json',
    }

    await axios(options)
    .then((res) => {
        setIsLoading(false)

        
        const message = res.data.response.message;
        const is_success = res.data.response.is_success;
        const settings = parseInt(res.data.response.settings);

        if (!is_success) {
            setShowMessageDialog(true)
            setMessageDialogMessage(message)
            return
        }
        
        setRemovePrintButtonSettings(settings)
        setRemovePrintButtonSettingsCurStatus(settings)

    })
    .catch((error) => {
        setIsLoading(false)

        setShowMessageDialog(true)
        setMessageDialogMessage(error)

    })
  }

  const fetchAutoGenerateInvoiceNumberSettings = async () => { 
    setIsLoading(true)

    const options = {
        method : "POST",
        url : '/TransactiLiteGeneralSettings/fetchAutoGenerateInvoiceNumberSettings.json',
    }

    await axios(options)
    .then((res) => {
        setIsLoading(false)

        
        const message = res.data.response.message;
        const is_success = res.data.response.is_success;
        const settings = res.data.response.settings;

        if (!is_success) {
          setShowMessageDialog(true)
          setMessageDialogMessage(message)
          return
      }
      
      setAutoSalesInvoiceNumberSettings(settings)

    })
    .catch((error) => {
        setIsLoading(false)

        setShowMessageDialog(true)
        setMessageDialogMessage(error)

    })
  }
  
  const messageDialog = () => {
      return(
          <Dialog
          fullWidth={true}
          maxWidth={'sm'}
          open={showMessageDialog}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{"Message"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
            {messageDialogMessage}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={()=>{
              
                  setShowMessageDialog(false)
                  
                }} 
              color="primary" autoFocus>
              Close
            </Button>
          </DialogActions>
        </Dialog>
        )
  }

  const progressDialog = () => {
      return(
        <Dialog
        fullWidth={true}
        maxWidth={'lg'}
        open={isSavingSettings}
        onClose={()=>{}}
      >
      
        <DialogContent>
          <DialogContentText>
            Saving Settings... Please wait...
          </DialogContentText>
          <LinearProgress color="secondary" />
        </DialogContent>
      </Dialog>
      )
  }

    const handleClickOpenResetPasswordDialog = () => {
        setOpenPasswordResetDialogSettings(true);
    };

    const handleClickCloseResetPasswordDialog = () => {
        setOpenPasswordResetDialogSettings(false);
    };

    const passwordResetDialog = () => {
      return (
        <div>
          {/* <Dialog open={openPasswordResetDialogSettings} onClose={handleClickCloseResetPasswordDialog}> */}
          <Dialog
            open={openPasswordResetDialogSettings}
            onClose={(event, reason) => {
              if (reason !== 'backdropClick') {
                handleClickCloseResetPasswordDialog();
              }
            }}
          >
            <DialogTitle> {"PASSWORD RESET SETTINGS"} </DialogTitle>
            
            <DialogContent>
              {renderPasswordIsExpMessage()}
              {renderPasswordPolicySettings()}
    
              <Grid container spacing={1} style={{ marginBottom: '.5rem' }}>
                <Grid item xs={12}>
                  <FormControl variant="outlined" fullWidth>
                    <InputLabel htmlFor="outlined-adornment-password">Old Password</InputLabel>
                    <OutlinedInput
                      id="old_password"
                      variant="outlined"
                      required  
                      fullWidth
                      type={showOldPassword ? 'password' : 'text'}
                      name="old_password"
                      label="Old Password"
                      autoComplete="on"
                      onChange={resetOldPasswordOnChange}
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={() => { setShowOldPassword(!showOldPassword); }}
                            onMouseDown={() => {}}
                            edge="end"
                          >
                            {showOldPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      }
                    />
                  </FormControl>
                </Grid>
    
                <Grid item xs={12}>
                  <FormControl variant="outlined" fullWidth>
                    <InputLabel htmlFor="outlined-adornment-password">New Password</InputLabel>
                    <OutlinedInput
                      id="new_password"
                      variant="outlined"
                      required
                      fullWidth
                      type={showPassword ? 'password' : 'text'}
                      name="new_password"
                      label="New Password"
                      autoComplete="on"
                      onChange={resetNewPasswordOnChange}
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={() => { setShowPassword(!showPassword); }}
                            onMouseDown={() => {}}
                            edge="end"
                          >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      }
                    />
                  </FormControl>
                </Grid>
    
                <Grid item xs={12}>
                  <FormControl variant="outlined" fullWidth>
                    <InputLabel htmlFor="outlined-adornment-password">Confirm Password</InputLabel>
                    <OutlinedInput
                      id="re_password"
                      type={showConfirmPassword ? 'password' : 'text'}
                      name="re_password"
                      label="Confirm Password"
                      autoComplete="on"
                      onChange={resetReNewPasswordOnChange}
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={() => { setConfirmShowPassword(!showConfirmPassword); }}
                            onMouseDown={() => {}}
                            edge="end"
                          >
                            {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      }
                    />
                  </FormControl>
                </Grid>
              </Grid>
            </DialogContent>
    
            <DialogActions>
              {/* Hide button if the password is expired */}
              {!props.isNeedToChangePassword && (
                <Button onClick={handleClickCloseResetPasswordDialog}>Cancel</Button>
              )}
              <Button color="primary" onClick={handleResetNewPasswordSettings}>Save</Button>
            </DialogActions>
          </Dialog>
        </div>
      );
    };

    const renderPasswordIsExpMessage = () => { 
      return (
        <>
        <Grid container spacing={1} style={{ marginBottom: '1rem', textAlign: 'center' }}>
          <Grid item xs={12} style={{ color: 'red' }}>
              {props.isNeedToChangePassword && (
                <div>
                  Your password has expired. You need to change your password.
                </div>
              )}
          </Grid>
        </Grid>
        </>
      )
    }
    
    const renderPasswordPolicySettings = () => {
      if (!passwordPolicySettings || passwordPolicySettings.length === 0 || !passwordPolicySettings.has_settings) {
        return null;
      }
    
      return (
        <Grid container spacing={1} style={{ marginBottom: '.5rem' }}>
          <Grid item xs={12}>
            <div>* Minimum character length: {passwordPolicySettings.minimum_password_length}</div>
            {passwordPolicySettings.require_upper && <div>* At least one uppercase letter (A-Z).</div>}
            {passwordPolicySettings.require_lower && <div>* At least one lowercase letter (a-z).</div>}
            {passwordPolicySettings.require_number && <div>* At least one number.</div>}
            {passwordPolicySettings.require_special_characters && (
              <div>* At least one special character (!@#$%^&*()_+-=[]{}|').</div>
            )}
          </Grid>
        </Grid>
      );
    };
    

    const handleResetNewPasswordSettings = async () => {

        setIsSavingSettings(true);
        setOpenPoDateDialog(false)

        const params = {
          newResetPassword : JSON.stringify(newResetPassword),
          isNeedToChangePassword : props.isNeedToChangePassword,
          passwordPolicySettings : JSON.stringify(passwordPolicySettings)
        }

        const options = {
            method: "POST",
            url: '/TransactiLiteGeneralSettings/saveResetPasswordSettings.json',
            data: objectToFormData(params)
        }

        await axios(options)
            .then((res) => { 

                setIsSavingSettings(false)
                const message = res.data.response.message;
                const is_success = res.data.response.is_success;

                if (is_success) {
                  setOpenPasswordResetDialogSettings(false)
                }

                setIsSavingSuccess(true)
                setShowMessageDialog(true)
                setMessageDialogMessage(message)

            })
            .catch((error) => {
                setIsSavingSettings(false)

                setShowMessageDialog(true)
                setMessageDialogMessage(error)
            })
    }

    const objectToFormData = (object) => Object.keys(object).reduce((formData, key) => {
        formData.append(key, object[key]);
        
      return formData;
    }, new FormData());



    return (
        <React.Fragment>
            <div>
                <CssBaseline />
                <AppBar position="fixed" className={classes.appBarTop} aria-haspopup="true" onClick={handleClick} ref={elementRef}>
                    <Toolbar sx={{ justifyContent: 'space-between' }}>
                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        onClick={props.handleDrawerToggle}
                        className={classes.menuButton}
                        size="large">
                        <MenuIcon />
                    </IconButton>
                    <Typography variant="h6" noWrap  className={classes.margin}>
                        Settings
                    </Typography>
                    </Toolbar>
                </AppBar>
                {settingsBody()}
                {
                    selectedSettings.name === "Seller Highlight SKU Settings" ? (
                        <HighlightSkuSettings
                            setOpenDialogSettings={setOpenDialogSettings}
                            openDialogSettings={openDialogSettings}
                            setSelectedSettings={setSelectedSettings}           
                            fetchTotalSKus = {fetchTotalSKus}
                        />
                    ) : null
                }
                {
                    selectedSettings.name === "User Settings" ||  openUserDialogSettings ? (
                        <UserEmailSettings
                            setOpenDialogSettings={setOpenUserDialogSettings}
                            openDialogSettings={openUserDialogSettings}
                        />
                    ) : null
                }
                {
                    selectedSettings.name === "Transacti Lite and Seller Auto-generate Invoice Number Setting" || openAutoGenInvoiceNumberDialog ? (
                      <AutoGenerateInvoiceNumberSettings 
                        openAutoGenInvoiceNumberDialog={openAutoGenInvoiceNumberDialog} 
                        setOpenAutoGenInvoiceNumberDialog={setOpenAutoGenInvoiceNumberDialog}
                        setAutoSalesInvoiceNumberSettings={setAutoSalesInvoiceNumberSettings}
                        autoSalesInvoiceNumberSettings={autoSalesInvoiceNumberSettings}
                        isLoading={isLoading}
                        setIsLoading={setIsLoading}
                        setIsSavingSettings={setIsSavingSettings}
                        setShowMessageDialog={setShowMessageDialog}
                        setMessageDialogMessage={setMessageDialogMessage}
                      />
                    ) : null
                }
                {
                    selectedSettings.name === "MFA Settings" ||  openMfaDialogSettings ? (
                        <MfaSettings
                            setOpenDialogSettings={setOpenMfaDialogSettings}
                            openDialogSettings={openMfaDialogSettings}
                        />
                    ) : null
                }
                {
                    selectedSettings.name === "Seller Password Policy Setting" ||  openSellerPasswordPolicyDialogSettings ? (
                        <PasswordPolicySettings
                            setOpenDialogSettings={setOpenSellerPasswordPolicyDialogSettings}
                            openDialogSettings={openSellerPasswordPolicyDialogSettings}
                        />
                    ) : null
                }
                
                <AppBar position="fixed" color="primary" className={classes.appBarBottom}>
            </AppBar>
            <StyledEngineProvider injectFirst>
                <ThemeProvider theme={materialTheme}>
                    {poDateSettingsDialog()}
                    {returnProductPageDialog()}
                    {removePrintButtonDialog()}
                    {messageDialog()}
                    {progressDialog()}
                    {passwordResetDialog()}
                    </ThemeProvider>
            </StyledEngineProvider>
            </div>
        </React.Fragment>
    )
}